import { CreateProps } from "react-admin";
import { DefaultCreate } from "../../../lib/components";
import {
  MediaFileSource,
  transformAndUploadS3Files,
} from "../../../lib/modules";
import { PurchaseGroupForm } from "./PurchaseGroupForm";
const PurchaseGroupCreate= (props: CreateProps) => {
  const mediaFileSources: MediaFileSource[] = [
    {
      source: "files",
      subFolder: "purchase-groups",
    },
  ];

  return (
    <DefaultCreate
      {...props}
      transform={transformAndUploadS3Files(mediaFileSources)}
    >
      <PurchaseGroupForm />
    </DefaultCreate>
  );
};

export { PurchaseGroupCreate };
